import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '../../../../../components/Header'

export const Title: React.FC = () => {
  const { t } = useTranslation()

  return <Header title={t('eInvoiceOverview.title.title')} />
}
